import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Reseller } from 'modules/Reseller/Reseller'
import { Equipment } from 'modules/Equipment/Equipment'
import { Device } from 'modules/Device/Device'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class OrgGroup extends Model {
  static override entity = 'org_groups'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare address: string | null
  @Attr(null) declare primary_contact_name: string | null
  @Attr(null) declare office_phone: string | null
  @Attr(null) declare mobile_phone: string | null
  @Attr(false) declare can_view_transactions: boolean
  @Attr(false) declare can_view_equipment: boolean
  @Attr(false) declare can_view_levels: boolean
  @Attr(false) declare can_view_reports: boolean
  @Attr(null) declare reseller_id: string | null

  @BelongsTo(() => Reseller, 'reseller_id') declare reseller: Reseller | null

  @HasMany(() => Equipment, 'equipment_id') declare equipments: Equipment[]
  @HasMany(() => Device, 'device_id') declare devices: Device[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
}
